import { Box, InputAdornment, TextField } from "@mui/material"
import { Search } from "react-feather"

export interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const SearchField = ({
  value,
  onChange,
  placeholder = "Rechercher",
}: SearchFieldProps) => (
  <Box sx={{ px: 2, pt: 1, pb: 1 }}>
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search size={16} />
            </InputAdornment>
          ),
        },
      }}
    />
  </Box>
)
